// ─── Sample Roach Data ────────────────────────────────────────────────────────
// Covers all 7 pulse contexts across Jan 2026.
// Overall entries mirror the original 8-day seed.
// Each other context has varied dates and scores to power
// Drift analysis and Campus dashboard work later.

const BASE = {
    subscriptionCycle: [1],
    subscriptionId: "sample-sub-1",
    user: "sample-user",
    userCode: "T5W001",
    setId: "1",
    isActive: true,
};

// ─── Helper: avg from lever string ───────────────────────────────────────────
const avg = (levers) => {
    const scores = levers.split(",").map(Number);
    return parseFloat((scores.reduce((a, b) => a + b, 0) / scores.length).toFixed(1));
};

const type = (a) => {
    if (a >= 8) return "⚡ Apex Chaos Roach";
    if (a >= 6) return "🔥 Hardened Survivalist";
    if (a <= 3) return "🧊 Low Energy Roach";
    return "🪳 Balanced Survivor";
};

const make = (id, ctx, date, dayNum, levers) => {
    const a = avg(levers);
    return {
        ...BASE,
        _id: id,
        pulseContext: ctx,
        roachDate: date,
        dayNumber: dayNum,
        levers,
        avgScore: a,
        type: type(a),
    };
};

// ─────────────────────────────────────────────────────────────────────────────
// OVERALL  (original 8 days, now with explicit pulseContext)
// ─────────────────────────────────────────────────────────────────────────────
const overallRoaches = [
    make("roach-o1", "Overall", "2026-01-01", 1,  "9,9,5,5,9,5,9"),
    make("roach-o2", "Overall", "2026-01-02", 2,  "5,5,5,5,9,5,9"),
    make("roach-o3", "Overall", "2026-01-03", 3,  "9,5,9,1,9,5,9"),
    make("roach-o4", "Overall", "2026-01-04", 4,  "1,1,5,1,5,1,5"),
    make("roach-o5", "Overall", "2026-01-05", 5,  "5,9,9,5,9,1,9"),
    make("roach-o6", "Overall", "2026-01-06", 6,  "9,9,9,5,9,1,9"),
    make("roach-o7", "Overall", "2026-01-07", 7,  "5,5,9,1,9,1,9"),
    make("roach-o8", "Overall", "2026-01-08", 8,  "9,5,9,5,9,1,9"),
    make("roach-o9", "Overall", "2026-01-10", 9,  "5,5,5,5,5,5,5"),
    make("roach-o10","Overall", "2026-01-12", 10, "9,9,9,9,9,1,5"),
    make("roach-o11","Overall", "2026-01-14", 11, "1,1,1,9,5,9,1"),
    make("roach-o12","Overall", "2026-01-16", 12, "9,5,9,5,9,5,9"),
];

// ─────────────────────────────────────────────────────────────────────────────
// HOME  — weekend/evening pressure, fatigue, family stress patterns
// ─────────────────────────────────────────────────────────────────────────────
const homeRoaches = [
    make("roach-h1", "Home", "2026-01-01", 1,  "5,5,9,1,5,9,5"),   // New Year fatigue
    make("roach-h2", "Home", "2026-01-03", 2,  "1,1,9,5,5,9,5"),   // Weekend low energy
    make("roach-h3", "Home", "2026-01-05", 3,  "9,5,9,1,1,5,9"),   // Domestic chaos
    make("roach-h4", "Home", "2026-01-07", 4,  "1,1,5,9,5,9,1"),   // Numb, scrolling
    make("roach-h5", "Home", "2026-01-08", 5,  "5,5,9,5,9,1,9"),   // Recovery day
    make("roach-h6", "Home", "2026-01-10", 6,  "9,9,5,1,5,5,9"),
    make("roach-h7", "Home", "2026-01-12", 7,  "1,5,9,9,1,9,1"),   // Doom scroll spike
    make("roach-h8", "Home", "2026-01-14", 8,  "5,5,9,5,9,1,9"),
    make("roach-h9", "Home", "2026-01-15", 9,  "9,5,9,1,9,1,9"),   // Strong recovery
    make("roach-h10","Home", "2026-01-17", 10, "1,1,1,9,1,9,1"),   // Burnout day
    make("roach-h11","Home", "2026-01-19", 11, "5,9,9,5,5,5,9"),
    make("roach-h12","Home", "2026-01-21", 12, "9,9,9,1,9,1,9"),
];

// ─────────────────────────────────────────────────────────────────────────────
// WORK  — high pressure, deadline weeks, recovery patterns
// ─────────────────────────────────────────────────────────────────────────────
const workRoaches = [
    make("roach-w1", "Work", "2026-01-02", 1,  "9,9,5,5,9,5,5"),   // Back to work Jan 2
    make("roach-w2", "Work", "2026-01-05", 2,  "9,9,1,5,9,5,9"),   // Deadline week starts
    make("roach-w3", "Work", "2026-01-06", 3,  "9,9,1,9,9,9,1"),   // Peak heat
    make("roach-w4", "Work", "2026-01-07", 4,  "5,9,5,9,5,9,1"),   // Mid-week burnout
    make("roach-w5", "Work", "2026-01-08", 5,  "1,5,9,9,5,5,5"),   // Post-deadline crash
    make("roach-w6", "Work", "2026-01-09", 6,  "5,5,9,5,9,1,9"),   // Recovery Friday
    make("roach-w7", "Work", "2026-01-12", 7,  "9,9,5,5,9,5,9"),   // New week energy
    make("roach-w8", "Work", "2026-01-13", 8,  "9,9,1,1,9,9,5"),   // High chaos + doom
    make("roach-w9", "Work", "2026-01-14", 9,  "5,5,9,5,9,1,9"),
    make("roach-w10","Work", "2026-01-15", 10, "1,1,9,9,5,5,9"),   // Focus recovered
    make("roach-w11","Work", "2026-01-16", 11, "9,9,9,1,9,1,9"),   // Grind mode
    make("roach-w12","Work", "2026-01-19", 12, "5,5,9,5,9,1,9"),
];

// ─────────────────────────────────────────────────────────────────────────────
// CAMPUS  — exam pressure, peer dynamics, focus vs distraction
// ─────────────────────────────────────────────────────────────────────────────
const campusRoaches = [
    make("roach-c1", "Campus", "2026-01-05", 1,  "5,5,9,5,9,5,9"),  // Semester starts
    make("roach-c2", "Campus", "2026-01-06", 2,  "9,5,9,1,9,5,9"),
    make("roach-c3", "Campus", "2026-01-07", 3,  "5,9,5,5,5,9,5"),  // Social distraction
    make("roach-c4", "Campus", "2026-01-08", 4,  "9,9,5,1,9,5,9"),  // Pre-exam build
    make("roach-c5", "Campus", "2026-01-09", 5,  "9,9,1,1,5,9,5"),  // Exam day chaos
    make("roach-c6", "Campus", "2026-01-12", 6,  "1,1,9,9,9,1,9"),  // Post-exam crash
    make("roach-c7", "Campus", "2026-01-13", 7,  "5,5,9,5,9,5,9"),  // Bounce back
    make("roach-c8", "Campus", "2026-01-14", 8,  "9,5,9,1,9,1,9"),
    make("roach-c9", "Campus", "2026-01-15", 9,  "5,9,9,5,9,9,1"),  // Doom scroll exam prep
    make("roach-c10","Campus", "2026-01-16", 10, "9,5,9,1,9,1,9"),
    make("roach-c11","Campus", "2026-01-19", 11, "1,5,9,9,5,9,5"),  // Low energy Monday
    make("roach-c12","Campus", "2026-01-20", 12, "9,9,9,1,9,1,9"),  // Grind week
    make("roach-c13","Campus", "2026-01-21", 13, "5,5,5,5,5,5,5"),  // Flat day
    make("roach-c14","Campus", "2026-01-22", 14, "9,9,9,5,9,1,9"),  // High performance
];

// ─────────────────────────────────────────────────────────────────────────────
// LEARNING  — self-study, courses, reading, skill building
// ─────────────────────────────────────────────────────────────────────────────
const learningRoaches = [
    make("roach-l1", "Learning", "2026-01-01", 1,  "1,1,9,5,9,5,9"),  // New Year resolve
    make("roach-l2", "Learning", "2026-01-03", 2,  "5,5,9,5,9,1,9"),
    make("roach-l3", "Learning", "2026-01-05", 3,  "9,5,9,1,9,1,9"),  // Deep work day
    make("roach-l4", "Learning", "2026-01-06", 4,  "5,5,5,5,5,5,5"),  // Flat day
    make("roach-l5", "Learning", "2026-01-08", 5,  "9,1,9,1,9,1,9"),  // Flow state
    make("roach-l6", "Learning", "2026-01-10", 6,  "1,5,9,9,1,9,1"),  // Numb, distracted
    make("roach-l7", "Learning", "2026-01-12", 7,  "9,5,9,1,9,1,9"),
    make("roach-l8", "Learning", "2026-01-14", 8,  "5,5,9,5,9,5,9"),
    make("roach-l9", "Learning", "2026-01-16", 9,  "9,1,9,1,9,1,9"),  // Peak learning day
    make("roach-l10","Learning", "2026-01-19", 10, "1,9,5,9,1,9,1"),  // Chaos disrupts study
    make("roach-l11","Learning", "2026-01-21", 11, "9,5,9,1,9,1,9"),
    make("roach-l12","Learning", "2026-01-22", 12, "5,9,9,5,9,9,1"),  // Distraction creep
];

// ─────────────────────────────────────────────────────────────────────────────
// SOCIAL  — people energy, peer pressure, events, isolation
// ─────────────────────────────────────────────────────────────────────────────
const socialRoaches = [
    make("roach-s1", "Social", "2026-01-01", 1,  "9,5,9,1,5,9,9"),  // New Year gathering
    make("roach-s2", "Social", "2026-01-03", 2,  "5,5,9,5,5,9,5"),
    make("roach-s3", "Social", "2026-01-07", 3,  "1,1,9,9,1,9,1"),  // Isolation day
    make("roach-s4", "Social", "2026-01-10", 4,  "9,5,9,1,9,5,9"),
    make("roach-s5", "Social", "2026-01-14", 5,  "5,9,9,5,5,9,5"),
    make("roach-s6", "Social", "2026-01-17", 6,  "9,5,9,1,9,1,9"),
    make("roach-s7", "Social", "2026-01-21", 7,  "1,1,5,9,5,9,1"),  // Withdrawn
];

// ─────────────────────────────────────────────────────────────────────────────
// ENVIRONMENT  — city/area energy, commute, weather, surroundings
// ─────────────────────────────────────────────────────────────────────────────
const environmentRoaches = [
    make("roach-e1", "Environment", "2026-01-02", 1,  "9,9,5,5,5,5,9"),
    make("roach-e2", "Environment", "2026-01-05", 2,  "5,9,9,1,5,5,9"),
    make("roach-e3", "Environment", "2026-01-09", 3,  "1,5,9,9,5,9,1"),
    make("roach-e4", "Environment", "2026-01-13", 4,  "9,9,5,1,9,1,9"),
    make("roach-e5", "Environment", "2026-01-17", 5,  "5,5,9,5,9,5,9"),
    make("roach-e6", "Environment", "2026-01-21", 6,  "9,9,9,1,9,1,9"),
];

// ─────────────────────────────────────────────────────────────────────────────
// EXPORT: all combined (used when no context filter is applied)
// ─────────────────────────────────────────────────────────────────────────────
export const sampleRoaches = [
    ...overallRoaches,
    ...homeRoaches,
    ...workRoaches,
    ...campusRoaches,
    ...learningRoaches,
    ...socialRoaches,
    ...environmentRoaches,
];

// ─────────────────────────────────────────────────────────────────────────────
// EXPORT: filtered by context — use this in the component
// ─────────────────────────────────────────────────────────────────────────────
export const getSampleByContext = (context) => {
    if (!context || context === "All") return sampleRoaches;
    return sampleRoaches.filter((r) => r.pulseContext === context);
};

// ─────────────────────────────────────────────────────────────────────────────
// EXPORT: individual context arrays — useful for Campus/Drift dashboards later
// ─────────────────────────────────────────────────────────────────────────────
export const sampleByContext = {
    Overall:     overallRoaches,
    Home:        homeRoaches,
    Work:        workRoaches,
    Campus:      campusRoaches,
    Learning:    learningRoaches,
    Social:      socialRoaches,
    Environment: environmentRoaches,
};
